import register from '@kpsys/angularjs-register';
import valueEditorsBaseModule from './value-editors.base.module';
import {valueEditorsOptionsConfig} from './value-editors-options.config';
import {valueEditorsLocalizationsConfig} from './value-editors-localization.config';
import RecordValueEditorService from './custom-editors-services/record-value-editor.service';
import SearchableValueEditorService from './custom-editors-services/searchable-value-editor.service';
import {Field7ValueEditorService} from './custom-editors-services/field7-value-editor.service';
import {Field8ValueEditorService} from './custom-editors-services/field8-value-editor.service';

export default register('portaro.value-editors.portaro-editors', [valueEditorsBaseModule])
    .run(valueEditorsOptionsConfig)
    .run(valueEditorsLocalizationsConfig)
    .service(RecordValueEditorService.serviceName, RecordValueEditorService)
    .service(SearchableValueEditorService.serviceName, SearchableValueEditorService)
    .service(Field7ValueEditorService.serviceName, Field7ValueEditorService)
    .service(Field8ValueEditorService.serviceName, Field8ValueEditorService)
    .name();